<template>
  <v-dialog :value="display" max-width="430px" persistent>
    <v-card class="pa-2">
      <v-card-text class="pt-4">
        {{ translations.foremanClockInReplacementWarning }}
      </v-card-text>

      <v-card-actions class="d-flex justify-end">
        <v-btn small text @click="$emit('close')">
          {{ translations.close }}
        </v-btn>
        <v-btn small color="main" dark depressed @click="$emit('confirm')">
          {{ translations.confirm }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { translations } from '@/utils/common'

export default {
  name: 'ForemanClockInWarningDialog',

  props: {
    display: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    translations: () => translations
  }
}
</script>
